import axios from 'axios';

// const API_URL = 'http://localhost:5001/api/auth';
const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/auth`;

export const login = async (email: string, password: string) => {
    try {
      const response = await axios.post(`${API_URL}/login`, { email, password });
      return { 
        token: response.data.token, 
        name: response.data.name || email.split('@')[0] // Use email prefix if name is not provided
      };
    } catch (error: any) {
      if (axios.isAxiosError(error) && error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        throw new Error(error.response.data.message || `Server error: ${error.response.status}`);
      } else if (axios.isAxiosError(error) && error.request) {
        // The request was made but no response was received
        throw new Error('No response received from server');
      } else {
        // Something happened in setting up the request that triggered an Error
        throw new Error('An unexpected error occurred');
      }
    }
  };

export const register = async (name: string, email: string, password: string) => {
    try {
      const response = await axios.post(`${API_URL}/register`, { name, email, password });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        throw new Error(error.response.data.message || 'Registration failed');
      }
      throw new Error('An unexpected error occurred');
    }
  };

export const forgotPassword = async (email: string) => {
  const response = await axios.post(`${API_URL}/forgot-password`, { email });
  return response.data;
};

export const resetPassword = async (token: string, password: string) => {
  const response = await axios.post(`${API_URL}/reset-password/${token}`, { password });
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
};